export class GitlabAuthRequiredError extends Error {
  readonly name = 'GitlabAuthRequiredError';

  constructor() {
    super('GitLab authorization is required');
  }
}

export function isGitlabAuthRequiredError(error: unknown): boolean {
  if (error instanceof GitlabAuthRequiredError) {
    return true;
  }
  return (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    (error as { name: string }).name === 'GitlabAuthRequiredError'
  );
}
